/* eslint react/no-did-mount-set-state: 0 */
/* eslint consistent-return: 0 */
/* eslint react/prop-types: 0 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import _ from 'lodash';
import TelemedicinaPageUserLoggedIn from './TelemedicinaPageUserLoggedIn';
import NotLoggedIn from '../../components/NotLoggedIn/NotLoggedIn';
import TurnosSolicitud from '../../components/Telemedicina/TurnosSolicitud/TurnosSolicitud';

import {
  LOGIN_STATUS_PENDING,
  LOGIN_STATUS_NOT_LOGGED_IN,
  LOGIN_STATUS_LOGGED_IN,
  NOT_LOGGED_IN_INIT_SESSION_MSG,
} from '../../constants';

class TelemedicinaPage extends React.Component {
  constructor() {
    super();
    this.state = {
      isLoggedIn: LOGIN_STATUS_PENDING,
    };
  }

  componentDidMount() {
    const { auth } = this.props;
    if (_.isEmpty(auth)) {
      this.setState({ isLoggedIn: LOGIN_STATUS_NOT_LOGGED_IN });
    } else {
      this.setState({ isLoggedIn: LOGIN_STATUS_LOGGED_IN });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (_.isEmpty(nextProps.auth)) {
      this.setState({ isLoggedIn: LOGIN_STATUS_NOT_LOGGED_IN });
    } else {
      this.setState({ isLoggedIn: LOGIN_STATUS_LOGGED_IN });
    }
  }

  render() {
    const { isLoggedIn } = this.state;

    switch (isLoggedIn) {
      case LOGIN_STATUS_LOGGED_IN:
        return (
          <TelemedicinaPageUserLoggedIn
            component={TurnosSolicitud}
            activeSolicitud
            context={this.props.context}
            origen="espontaneo"
          />
        );

      case LOGIN_STATUS_NOT_LOGGED_IN:
        return (
          <NotLoggedIn>
            {NOT_LOGGED_IN_INIT_SESSION_MSG}
          </NotLoggedIn>
        );

      case LOGIN_STATUS_PENDING:
        return <div />;

      default:
        return <div />;
    }
  }
}

const mapStateToProps = state => ({
  auth: state.auth.loginResponse,
});

export default connect(mapStateToProps, null)(withStyles()(TelemedicinaPage));



// WEBPACK FOOTER //
// ./src/routes/telemedicina/TelemedicinaPage.js